import {Component, Mixins} from 'vue-property-decorator';
import {CALLS_EVENTS, COMMAND_TYPE} from '@/components/calls/values/calls.values';
import {APP_SOCKET_EVENTS} from '@/core/values/app.values';
import {CallsSipMixin} from '@/components/calls/services/sip/calls.sip.mixin';
import {TOAST_TYPES} from '@/plugins/ed-toast/values/ed-toast.values';
import {MEETINGS_STORE} from '@/meetings/store/meetings.store';

/**
 * Call Socket functions
 */
@Component({})
export class CallsSocketMixin extends Mixins(CallsSipMixin) {

    private LISTEN_COMMAND_FUNCTION : string = 'listenCommandCall';

    //-- -----------------------------------------------------------------------------------------------------------------
    //-- Hooks
    mounted() {
        this.$edEventBus.$on(CALLS_EVENTS.CREATE_CALL_COMMAND, this.sendCommandCall);
        this.$edEventBus.$on(this.LISTEN_COMMAND_FUNCTION, this.listenCommandCall);
    }

    unmounted() {
        this.$edEventBus.$off(CALLS_EVENTS.CREATE_CALL_COMMAND);
        this.$edEventBus.$off(this.LISTEN_COMMAND_FUNCTION);
    }

    //-- -----------------------------------------------------------------------------------------------------------------
    //-- Functions

    sendCommandCall(message: any) {
        let data = {
            messageType: APP_SOCKET_EVENTS.COMMAND_CALL_REQUEST,
            username: this.$store.state.AuthStore.user.fullName,
            topicId: this.$store.state.CallsStore.callConf.classId,

            userId: this.currentUserId,
            isTeacher: this.isTeacher,
            meetingId: this.$store.state.CallsStore.callConf.meetingId,
            classId: this.$store.state.CallsStore.callConf.classId,
            ...message
        }
        this.$EdSocket.emit(APP_SOCKET_EVENTS.COMMAND_CALL_REQUEST, data);
    }

    listenCommandCall(message: any) {
        if (this.isOnCall()){
            if (message.userId !== this.currentUserId){
                if (message.commandType === COMMAND_TYPE.MUTE_ALL ||
                        message.commandType === COMMAND_TYPE.UNMUTE_ALL) {
                    this.spRefreshCall().then(()=>{
                        this.showAlertMute(message.commandType === COMMAND_TYPE.MUTE_ALL);
                    });
                }else if (message.commandType === COMMAND_TYPE.MUTE ||
                            message.commandType === COMMAND_TYPE.UNMUTE) {
                    this.spRefreshCall().then(()=>{
                        if(message.muteUserId === this.currentUserId) {
                            this.showAlertMute(message.mute);
                        }
                    });
                } else if (message.commandType === COMMAND_TYPE.KICKOUT ||
                    message.commandType === COMMAND_TYPE.UNKICKOUT){
                    if(message.kickUserId === this.currentUserId) {
                        this.asyncCallCommandKick(message.commandType === COMMAND_TYPE.KICKOUT, false, message);
                    }else{
                        this.spRefreshCall();
                    }
                } else if (message.commandType === COMMAND_TYPE.LOCK || message.commandType === COMMAND_TYPE.UNLOCK){
                    this.asyncCallCommandLock(message.locked);
                }
            }
            if (message.commandType === COMMAND_TYPE.HANGUP) {
                this.asyncCallCommandHangup(message);
            }
        }else {
            //-- Message when the user is not in call
            if (message.commandType === COMMAND_TYPE.UNKICKOUT) {
                if (message.kickUserId === this.currentUserId) {
                    this.asyncCallCommandKick(false, false, message);
                }
            } else if (message.commandType === COMMAND_TYPE.HANGUP) {
                this.asyncCallCommandHangup(message);
            }
        }
    }

    showAlertMute(mute:boolean){
        if (mute){
            this.$EdToast.create({
                msg:  `${this.$t('common.wasMuted')}`,
                type: TOAST_TYPES.WARNING,
                top: '3rem',
                timeout: 3000
            });
        }
    }

    /**
     * Respond to the mute message.
     */
    asyncCallCommandMute(mute:boolean, all: boolean){
        //-- Get info meeting from cache
        this.currentCall(this.meet.meetingId).then((meet)=>{
            this.spSetMeet(meet);
            return Promise.resolve();
        }).then(()=>{
            return this.spUpdateLocalStateFromCache();
        }).then(()=>{
            if (mute){
                this.$EdToast.create({
                    msg:  `${this.$t('common.wasMuted')}`,
                    type: TOAST_TYPES.WARNING,
                    top: '3rem',
                    timeout: 3000
                });
            }
        }).then(()=>{
            this.$edEventBus.$emit(CALLS_EVENTS.PARTICIPANT_CHANGED,this.currentUserId);
        });
    }

    /**
     * Respond to the mute message.
     */
    asyncCallCommandKick(kickout:boolean, all: boolean, message:any){
        let _this = this;
        if (kickout){
            this.$EdToast.create({
                msg:  `${this.$t('common.wasKickouted')}`,
                type: TOAST_TYPES.WARNING,
                top: '3rem',
                timeout: 3000
            });
        }else{
            this.$EdToast.create({
                msg:  `${this.$t('common.wasGrantToCall', { className: message.className})}`,
                type: TOAST_TYPES.WARNING,
                top: '3rem',
                timeout: 3000
            });
        }
        _this.$edEventBus.$emit(CALLS_EVENTS.PARTICIPANT_CHANGED,this.currentUserId);
    }

    /**
     * Respond to the mute message.
     */
    asyncCallCommandLock(lock: boolean){
        let _this = this;
        this.currentCall(this.meet.meetingId).then((meet)=>{
            _this.spSetMeet(meet);
            return Promise.resolve();
        }).then(()=>{
            return _this.spUpdateLocalStateFromCache();
        }).then(()=>{
            _this.$edEventBus.$emit(CALLS_EVENTS.PARTICIPANT_CHANGED,this.currentUserId);
        });
    }

    asyncCallCommandHangup(message: any){
        if (this.isOnCall() && message.meetingId == this.meet.meetingId){
            this.getAsteriskUserInfo(this.call.classId)
            .then(()=>this.$store.dispatch(MEETINGS_STORE.ACTIONS.FETCH_LIVE_MEETINGS))
            .then(()=>this.$edEventBus.$emit(CALLS_EVENTS.PARTICIPANT_CHANGED,this.currentUserId))
        }else{
            this.$store.dispatch(MEETINGS_STORE.ACTIONS.FETCH_LIVE_MEETINGS);
        }
    }
}
